import React, { useState } from "react";
import "./BodyFatCalculator.css";
import BodyFatFAQ from "./components/BodyFatFAQ/BodyFatFAQ";
import BodyFatContent from "./components/BodyFatContent/BodyFatContent";

const BodyFatCalculator = () => {
  const [age, setAge] = useState("");
  const [weight, setWeight] = useState("");
  const [weightUnit, setWeightUnit] = useState("kg");
  const [waist, setWaist] = useState("");
  const [waistUnit, setWaistUnit] = useState("cm");
  const [gender, setGender] = useState("Male");
  const [bodyFat, setBodyFat] = useState(null);

  const convertWeightToKg = (weight, unit) => {
    if (unit === "kg") return parseFloat(weight);
    if (unit === "lb") return parseFloat(weight) * 0.453592;
    if (unit === "stones") return parseFloat(weight) * 6.35029;
    return 0; // Default for invalid input
  };

  const convertWaistToCm = (waist, unit) => {
    if (unit === "cm") return parseFloat(waist);
    if (unit === "inches") return parseFloat(waist) * 2.54;
    return 0; // Default for invalid input
  };

  const calculateBodyFat = () => {
    const weightInKg = convertWeightToKg(weight, weightUnit);
    const waistInCm = convertWaistToCm(waist, waistUnit);

    if (
      isNaN(weightInKg) ||
      weightInKg <= 0 ||
      isNaN(waistInCm) ||
      waistInCm <= 0
    ) {
      setBodyFat("Please enter valid values for weight and waist.");
      return;
    }

    let bodyFatPercentage;
    if (gender === "Male") {
      bodyFatPercentage =
        495 /
          (1.0324 -
            0.19077 * Math.log10(waistInCm - age) +
            0.15456 * Math.log10(weightInKg)) -
        450;
    } else {
      bodyFatPercentage =
        495 /
          (1.29579 -
            0.35004 * Math.log10(waistInCm + weightInKg - age) +
            0.221 * Math.log10(weightInKg)) -
        450;
    }

    setBodyFat(bodyFatPercentage.toFixed(2));
  };

  return (
    <div className="body-fat-calculator">
      <div className="bmi-calculators-wrapper">
        <div>
          <h1>Body Fat Calculator</h1>
          <p>
            Estimating your body fat percentage is essential for understanding
            body composition, tracking fitness progress, and setting health
            goals. Enter your information to calculate an estimated body fat
            percentage.
          </p>
          <div className="input-container">
            <label htmlFor="age">Age:</label>
            <input
              type="number"
              id="age"
              value={age}
              onChange={(e) => setAge(e.target.value)}
              min="0"
              placeholder="Enter your age"
            />
          </div>

          <div className="input-container">
            <label htmlFor="weight">Weight:</label>
            <div className="input-wrapper">
              <input
                type="number"
                id="weight"
                value={weight}
                onChange={(e) => setWeight(e.target.value)}
                min="0"
                placeholder="Enter your weight"
              />
              <select
                id="weight-unit"
                value={weightUnit}
                onChange={(e) => setWeightUnit(e.target.value)}
              >
                <option value="kg">Kilograms (kg)</option>
                <option value="lb">Pounds (lb)</option>
                <option value="stones">Stones</option>
              </select>
            </div>
          </div>

          <div className="input-container">
            <label htmlFor="waist">Waist Circumference:</label>
            <div className="input-wrapper">
              <input
                type="number"
                id="waist"
                value={waist}
                onChange={(e) => setWaist(e.target.value)}
                min="0"
                placeholder="Enter your waist circumference"
              />
              <select
                id="waist-unit"
                value={waistUnit}
                onChange={(e) => setWaistUnit(e.target.value)}
              >
                <option value="cm">Centimeters (cm)</option>
                <option value="inches">Inches</option>
              </select>
            </div>
          </div>

          <div className="input-container">
            <label htmlFor="gender">Gender:</label>
            <select
              id="gender"
              value={gender}
              onChange={(e) => setGender(e.target.value)}
            >
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
          </div>

          <button onClick={calculateBodyFat}>Calculate Body Fat</button>

          {bodyFat && (
            <div className="output">
              <h2 className="output-title">Estimated Body Fat Percentage:</h2>
              <p className="output-value">{bodyFat} %</p>
            </div>
          )}
        </div>
      </div>

      <BodyFatContent />
      <BodyFatFAQ />
    </div>
  );
};

export default BodyFatCalculator;
